import 'amazon-connect-streams';
import moment from 'moment';
import axios from 'axios';
import { store } from '../store';
import { logError } from './error';
import { getCookie } from '../common/utils/cookie';

const { connect } = window;
let startTime;

export const markStart = () => {
  startTime = moment().toISOString();
  const token = localStorage.getItem('SessionToken');
  const { contactId } = store.getState().telephony;
  const { quoteID } = store.getState().quote;
  const { username } = store.getState().agent;
  const { contactTel, username: shopperUsername } = store.getState().values;
  // these are for use with the softphone
  //   (as opposed to enrollment inbound telephony)
  const { phone, softphoneQuoteId } = store.getState().softphone;
  const { shopperUsername: sUsername, effectiveDate } = store.getState().softphone;

  const softphoneOpenString = getCookie('softphoneOpen');
  let qid = quoteID;
  if (softphoneOpenString === 'true') qid = softphoneQuoteId; // if softphone is open use cookie value
  const data = {
    quote_id: qid,
    agent_username: username,
    shopper_username: sUsername || shopperUsername, // prefer softphone val
    call_start: startTime, // prefer softphone val
    call_end: null,
    phone_number: phone || contactTel,
    effective_date: effectiveDate,
  };
  if (startTime) {
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/telephony/agentcall/${contactId}/`,
      headers: { Authorization: `Token ${token}` },
      data,
    });
  }
};

export const markEnd = () => {
  const token = localStorage.getItem('SessionToken');
  const endTime = moment().toISOString();
  const { contactId } = store.getState().telephony;
  const { quoteID } = store.getState().quote;
  const { username } = store.getState().agent;
  const { contactTel, username: shopperUsername } = store.getState().values;
  // these are for use with the softphone
  //   (as opposed to enrollment inbound telephony)
  const { phone, softphoneQuoteId } = store.getState().softphone;
  const { shopperUsername: sUsername, effectiveDate } = store.getState().softphone;

  const softphoneOpenString = getCookie('softphoneOpen');
  let qid = quoteID;
  if (softphoneOpenString === 'true') qid = softphoneQuoteId; // if softphone is open use cookie value

  if (startTime) {
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/telephony/agentcall/${contactId}/`,
      headers: { Authorization: `Token ${token}` },
      data: {
        quote_id: qid,
        agent_username: username,
        shopper_username: sUsername || shopperUsername, // prefer softphone val
        call_start: startTime,
        call_end: endTime,
        phone_number: phone || contactTel, // prefer softphone val
        effective_date: effectiveDate,
      },
    }).finally(() => {
      startTime = null;
    });
  }
};

export const updateAgentStatus = (newStatus) => {
  connect.agent((agent) => {
    const states = agent.getAgentStates();
    const desiredState = states.find((state) => state.name === newStatus);

    agent.setStatus(desiredState);
  });
};

export const endCall = () => {
  const successCallback = () => {
    const duration = 0;
    store.dispatch({ type: 'SET_CALL_DURATION', duration });
    updateAgentStatus('Available');
  };
  const failureCallback = (err) => {
    console.log('************* CALL WONT END ERROR:');
    console.log(err);
    logError(err);
  };

  if (connect) {
    connect.agent((agent) => {
      const [contact] = agent.getContacts();
      if (contact) {
        // const status = contact.getStatus().type;
        // const duration = status === 'connected' ? contact.getStatusDuration() : 0;
        const connection = contact.getInitialConnection();
        connection.destroy({ success: successCallback, failure: failureCallback });
        contact.clear();
      }
    });
  }
};

export const connectLogout = () => {
  try {
    endCall();
  } catch (err) {
    console.error(err);
  }
  const baseConnectURL = store.getState().agent?.phoneInfo?.instanceDomain || '';
  console.log('------------ RUNNING CONNECT LOGOUT ------------------');

  return new Promise((resolve, reject) => {
    fetch(`https://${baseConnectURL}/connect/logout`, { credentials: 'include', mode: 'no-cors' })
      .then((res) => {
        connect.core.terminate();
        const containerDiv = document.getElementById('connect-iframe-container');
        const childIframe = document.querySelector('#connect-iframe-container iframe');
        if (childIframe) containerDiv.removeChild(childIframe);

        const lc = document.getElementById('connect-login-iframe-container');
        const ci = document.querySelector('#connect-login-iframe-container iframe');
        if (ci) lc.removeChild(ci);

        resolve(res.data);
      }).catch((err) => reject(err));
  });
};

const handleAuthError = (err) => {
  store.dispatch({ type: 'SET_CONNECT_LOGIN_STATUS', payload: false });
  store.dispatch({ type: 'SET_CALL_ERROR', error: err.message });
  console.log('!!!! AUTH ERR', err);
  logError(err);
  throw new Error('Authorization error.', { cause: 'authError' });
};

let hash = false;
const handleContactStatusChange = (status) => (contact) => {
  // Ensure any possible timer is cleared.
  window.clearInterval(hash);

  if (status === 'connecting') {
    store.dispatch({ type: 'SET_CALL_DURATION', duration: 0 });
  } else if (status === 'connected') {
    markStart();
    hash = window.setInterval(() => {
      const duration = contact.getStatusDuration();
      store.dispatch({ type: 'SET_CALL_DURATION', duration });
    }, 200);
  } else if (status === 'ended') {
    if (!contact.contactData) {
      markEnd();
      contact.clear();
    }
    updateAgentStatus('Available');
  } else if (status === 'destroy') {
    contact.clear();
  }

  store.dispatch({ type: 'UPDATE_CALL_STATUS', status });
};

const handleSoftphoneError = (err) => {
  // connectLogout();
  store.dispatch({ type: 'SET_CALL_ERROR', error: 'telephony error' });
  console.log('softphone error: ', err);
  throw new Error('Softphone error.', { cause: 'softphoneError' });
};

export const connectSSO = (agentUsername) => (
  new Promise((resolve, reject) => {
    const token = localStorage.getItem('SessionToken');
    store.dispatch({ type: 'UPDATE_AGENT_STATE', newState: 'Authenticating' });
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/telephony/phonelogin/${agentUsername}/`,
      method: 'get',
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  })
);

export const initCCP = (samlData, instanceDomain) => {
  console.log('******************************************* initCCP() ');
  try {
    connect.getLog().setEchoLevel(connect.LogLevel.ERROR);
    const containerDiv = document.getElementById('connect-iframe-container');

    // if the iframe exists from a previous login we need to find and destroy it first
    const childIframe = document.querySelector('#connect-iframe-container iframe');
    if (childIframe) containerDiv.removeChild(childIframe);
    // -- end destroy iframe

    // create a separate iframe to login, loginUrl param in connect.initCCP does not
    // work for our use case because it requires a popup window. I scoured through
    // the amazon-connect-streams source code to find this information.
    // let iframeLoaded = false;
    const loginIframe = document.createElement('iframe');
    loginIframe.src = `${window.location.origin}/saml`;
    // loginIframe.onload = () => { iframeLoaded = true; };
    const loginContainer = document.getElementById('connect-login-iframe-container');
    const preExistingLoginIframe = document.querySelector('#connect-login-iframe-container iframe');
    if (preExistingLoginIframe) {
      loginContainer.removeChild(preExistingLoginIframe);
    }
    loginContainer.appendChild(loginIframe);
    // we need to wait until the page is loaded. Set an interval to check when
    // the iframe is loaded so we can send the saml data to it. We don't want to
    // ever leave this interval uncleared so stop it from running after 10 seconds
    // (20 iterations, 1 iteration per 500ms).
    //
    const iframeWindow = (loginIframe.contentWindow || loginIframe.contentDocument);
    iframeWindow.onload = () => {
      // set a timeout after the page has loaded, just for good measure...
      setTimeout(() => iframeWindow.postMessage(samlData, window.location.origin), 1000);
    };
    // -- end login iframe code

    connect.core.initCCP(containerDiv, {
      ccpUrl: `https://${instanceDomain}/connect/ccp-v2/`,
      // loginUrl: loginURL,
      loginPopup: false,
      softphone: {
        allowFramedSoftphone: true,
        disableRingtone: false,
      },
    });
    connect.core.onAuthFail(handleAuthError);
    connect.core.onAccessDenied(handleAuthError);
    connect.core.onInitialized(() => {
      console.log('****** [CONNECTED VIA WEBSOCKET; OnInitialized callback]');
      // store.dispatch({ type: 'CLEAR_IFRAME' });
      const lc = document.getElementById('connect-login-iframe-container');
      const ci = document.querySelector('#connect-login-iframe-container iframe');
      if (ci) lc.removeChild(ci);
    });
    connect.core.onSoftphoneSessionInit(() => {
      console.log('****** [CONNECTED VIA WEBSOCKET; onSoftphoneSessionInit callback]');
      // store.dispatch({ type: 'CLEAR_IFRAME' });
    });

    connect.contact((contact) => {
      contact.onConnecting(handleContactStatusChange('connecting'));
      contact.onEnded(handleContactStatusChange('ended'));
      contact.onDestroy(handleContactStatusChange('destroy'));
      contact.onConnected(handleContactStatusChange('connected'));
      contact.onACW(handleContactStatusChange('acw'));
      contact.onIncoming(handleContactStatusChange('incoming'));
      contact.onAccepted(handleContactStatusChange('accepted'));
      contact.onMissed(handleContactStatusChange('missed'));

      const id = contact.getContactId();
      store.dispatch({ type: 'SET_CALL_ID', id });
    });

    connect.agent((agent) => {
      updateAgentStatus('Available');
      store.dispatch({ type: 'UPDATE_CALL_STATUS', status: 'acw' });
      store.dispatch({ type: 'LOAD_CCP_AGENT', data: agent.getConfiguration() });
      agent.onStateChange(({ newState }) => {
        store.dispatch({ type: 'UPDATE_AGENT_STATE', newState });
      });
      agent.onSoftphoneError(handleSoftphoneError);
    });
  } catch (err) {
    // store.dispatch({ type: 'CLEAR_IFRAME' });
    console.error('[ERROR CREATING CONNECT LOGIN IFRAME]');
    // throw new Error(err.message);
    console.log(err);
  }
};

export const placeCall = (phone) => {
  let shopperPhone = phone;
  if (!phone) {
    shopperPhone = store.getState().responses.shopper_phone;
  }

  const endpoint = connect.Endpoint.byPhoneNumber(shopperPhone);
  connect.agent((agent) => {
    agent.connect(endpoint, {
      failure: (err) => {
        console.log('********* error: ', err);
        const { type } = JSON.parse(err);
        let error = 'Something went wrong. Please contact support.';
        if (type === 'BadEndpointException') {
          error = 'Could not reach that destination. Please check the number and try again.';
        }
        store.dispatch({ type: 'SET_CALL_ERROR', error });
        store.dispatch({ type: 'UPDATE_CALL_STATUS', status: 'error' });
      },
    });
  });
};

export const sendSMS = (contactTel) => {
  const token = localStorage.getItem('SessionToken');
  const { quoteID } = store.getState().quote;
  const { username } = store.getState().agent;
  const { username: shopperUsername } = store.getState().shopper;

  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/telephony/inboundcall/`,
    headers: { Authorization: `Token ${token}` },
    data: {
      agent_username: username,
      shopper_username: shopperUsername,
      callerid: contactTel,
      send_sms: true,
      quote_id: quoteID,
    },
  });
};

export const acceptIncoming = () => {
  connect.agent((agent) => {
    const [contact] = agent.getContacts();
    if (contact) {
      const status = contact.getStatus().type;
      if (status === 'connecting') {
        contact.accept();
      }
    }
  });
};

export const toggleMute = () => {
  const { muted } = store.getState().telephony;

  connect.agent((agent) => {
    if (muted) {
      agent.unmute();
      store.dispatch({ type: 'UNMUTE_CALL' });
    } else {
      agent.mute();
      store.dispatch({ type: 'MUTE_CALL' });
    }
  });
};

// Terminate the connect login process if it goes too long
export const resetIfTimeout = () => {
  console.log('****** running resetIfTimeout()...');
  const { agentState, status } = store.getState().telephony;
  if (agentState === 'Authenticating' || status === 'noauth') {
    console.log('*****[TIMEOUT LOGGING INTO CONNECT, TERMINATING ATTEMPT]');
    try {
      connectLogout();
    } catch (err) {
      console.error(err);
    }
    store.dispatch({ type: 'SET_CONNECT_LOGIN_STATUS', payload: false });
    store.dispatch({ type: 'CLEAR_IFRAME' });
    store.dispatch({ type: 'CLEAR_TELEPHONY' });
    return Promise.reject();
  }
  return Promise.resolve();
};
